
// List of constant images
// ---- aboutScreen
export const kAboutScreenImages = {
    letterFox: 'images/aboutScreen/letterFoxIllustration.png',
    missionFox: '/images/aboutScreen/AboutMissionFoxIllustration.png',
}

// ---- Exercisers
export const kExerciserImages = {
    logoText: '/images/SystemExerciserLogoText.png',
}

// ---- flashScreen
export const kFlashImages = {
    logoText: '/images/SystemFlashLogoText.png',
    noGradeSelected: "/images/courses/CoursesBookIllustration.png",
}

// ---- Games
export const kGamesImages = {
    looseImage: "/images/fox/SystemConfusedFox.png",
    recordImage: "/images/fox/SystemStarsFox.png",
    successImage: "/images/fox/SystemHappyFox.png",
}

export const kHomeScreenImages = {
    foxWithPhone: "/images/homeScreen/HomePhoneIllustration.png",
}

// ---- SYSTEM
export const kSystemImages = {
    // Fox
    approvingFox: "/images/fox/SystemApprovingFox.png",
    blinkingFox: "/images/fox/SystemBlinkingFox.png",
    confusedFox: "/images/fox/SystemConfusedFox.png",
    cryingFox: "/images/fox/SystemCryingFox.png",
    happyFox: "/images/fox/SystemHappyFox.png",
    lovingFox: "/images/fox/SystemLovingFox.png",
    scepticalFox: "/images/fox/SystemScepticalFox.png",
    starsFox: "/images/fox/SystemStarsFox.png",
    // Others
    flashLogo: "/images/SystemFlashLogo.png",
    getItOnAppStore: "/images/SystemGetItOnAppStore.png",
    getIsOnPlayStore: "/images/SystemGetItOnPlayStore.png",
    dividerStar: "/images/SystemQuestionDividerStar.png",
    routeNotFound: "/images/System404ErrorImage.png",
    neoUmmiaLogo: '/images/SystemUmmiaLogo.png',
    neoUmmiaLogoText: '/images/SystemUmmiaNeoLogoText.png',
    neoUmmiaDarkLogoText: '/images/SystemUmmiaNeoDarkLogoText.png',
}